import { Drawer as MUIDrawer } from '@mui/material'
export interface IDrawerProps {
  open: boolean
  onClose?: () => void
  children: React.ReactNode
  anchor?: 'left' | 'right' | 'top' | 'bottom'
  minWidth?: number
  variant?: 'permanent' | 'temporary' | 'persistent'
  sx?: React.CSSProperties
}
export default function Drawer({ open, onClose, children, anchor, minWidth, variant, sx }: IDrawerProps) {
  return (
    <MUIDrawer
      open={open}
      onClose={onClose}
      anchor={anchor}
      variant={variant}
      sx={{
        ...sx,
        '& .MuiDrawer-paper': {
          minWidth,
          maxWidth: '50%',
          boxSizing: 'border-box',
          borderRadius: '10px',
        },
      }}
    >
      {children}
    </MUIDrawer>
  )
}
